import { fetchPPPTypesQuery, useAxiosInstance, usePoQuery } from '@gov-nx/api';
import { hasProperties } from '@gov-nx/core/types';

export const usePPPTypesQuery = () => {
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery({
		queryKey: ['pppTypes'],
		queryFn: () => fetchPPPTypesQuery(axiosInstance),
	});

	const options =
		query.data?.typy?.filter(hasProperties(['kod', 'nazev'])).map((typ) => ({
			label: typ.nazev,
			value: typ.kod,
		})) ?? [];

	return {
		...query,
		options,
	};
};
